import { render } from "./DomainListInput.vue?vue&type=template&id=bf7cf582"
import script from "./DomainListInput.vue?vue&type=script&lang=js"
export * from "./DomainListInput.vue?vue&type=script&lang=js"

import exportComponent from "/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__